import stepsBar from './Main.vue';
export default stepsBar;